module.exports = __webpack_public_path__ + "085ef30ed32b9f1bd1dbddf119eb2525.svg";